ReactContentQuery.ExternalScripts.loadArrow = {
    onPostRender: function (wpContext, handlebarsContext) {
        SystemJS.import("/SiteAssets/js/melia.js").then(function (r) {
            return SystemJS.import("components/retails").then(function (s) {
                s.Retails.prototype.arrowDisplay();
            })
        })
    }
};